import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { resetPassword } from '../../redux/actions/userActions';
import chesssLogo from '../../images/chessslogo.png';

const ForgotPasswordMobile = ({ resetPassword, UI }) => {
  const [formData, setFormData] = useState({
    email: ''
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const history = useHistory();

  // Update errors from Redux
  useEffect(() => {
    if (UI.errors) {
      setErrors(UI.errors);
    }
  }, [UI.errors]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Client-side validation
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    resetPassword(formData, () => setSuccess(true));
  };

  const isFormValid = formData.email.trim() !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim());
  const isDisabled = UI.loading || !isFormValid;

  return (
    <div style={{
      width: '100vw',
      minHeight: '100vh',
      backgroundColor: '#000',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      boxSizing: 'border-box',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch'
    }}>
      {/* Back Button
      <button
        onClick={() => history.goBack()}
        style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          backgroundColor: 'transparent',
          border: 'none',
          color: 'white',
          fontSize: '20px',
          cursor: 'pointer',
          padding: '10px'
        }}
      >
        ← Back
      </button> */}

      {/* Logo and Title */}
      <div style={{
        textAlign: 'center',
        marginBottom: '30px',
        flexShrink: 0
      }}>
        <img
          src={chesssLogo}
          alt="ChessThread"
          style={{
            width: '80px',
            height: '80px',
            marginBottom: '20px'
          }}
        />
        <h1 style={{
          color: 'gold',
          fontSize: '28px',
          fontWeight: 'bold',
          margin: 0,
          marginBottom: '10px'
        }}>
          Reset Password
        </h1>
        {!success && (
          <p style={{
            color: '#888',
            fontSize: '16px',
            margin: 0,
            maxWidth: '320px',
            lineHeight: '1.4'
          }}>
            Enter your email address and we'll send you a link to reset your password
          </p>
        )}
      </div>

      {!success ? (
        <form onSubmit={handleSubmit} style={{
          width: '100%',
          maxWidth: '400px',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          flexShrink: 0
        }}>
          {/* Email Field */}
          <div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '8px'
            }}>
              <label style={{
                color: '#ccc',
                fontSize: '14px'
              }}>
                Email Address
              </label>
              {errors.email && (
                <div style={{ color: '#ff0050', fontSize: '12px' }}>
                  {errors.email}
                </div>
              )}
            </div>
            <input
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email address"
              autoComplete="email"
              style={{
                width: '100%',
                padding: '12px 16px',
                backgroundColor: '#ffffff',
                border: errors.email ? '2px solid #ff0050' : '2px solid #ccc',
                borderRadius: '8px',
                color: '#000000',
                fontSize: '16px',
                outline: 'none',
                boxSizing: 'border-box',
                transition: 'border-color 0.3s ease'
              }}
              onFocus={(e) => {
                if (!errors.email) {
                  e.target.style.borderColor = 'gold';
                }
              }}
              onBlur={(e) => {
                if (!errors.email) {
                  e.target.style.borderColor = '#ccc';
                }
              }}
            />
          </div>

          {/* General Error */}
          {errors.general && (
            <div style={{
              color: '#ff0050',
              fontSize: '14px',
              textAlign: 'center',
              backgroundColor: 'rgba(255, 0, 80, 0.1)',
              padding: '14px',
              borderRadius: '10px',
              border: '1px solid rgba(255, 0, 80, 0.3)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}>
              <span>❌</span> {errors.general}
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isDisabled}
            style={{
              width: '100%',
              padding: '18px',
              backgroundColor: isDisabled ? '#666' : '#ff0050',
              background: isDisabled ? '#666' : 'linear-gradient(135deg, #ff0050, #ff4081)',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontSize: '18px',
              fontWeight: 'bold',
              cursor: isDisabled ? 'default' : 'pointer',
              opacity: isDisabled ? 0.7 : 1,
              marginTop: '10px',
              transition: 'all 0.3s ease',
              transform: isDisabled ? 'none' : 'scale(1)',
              boxShadow: isDisabled ? 'none' : '0 4px 15px rgba(255, 0, 80, 0.3)'
            }}
            onMouseDown={(e) => {
              if (!isDisabled) {
                e.target.style.transform = 'scale(0.98)';
              }
            }}
            onMouseUp={(e) => {
              if (!isDisabled) {
                e.target.style.transform = 'scale(1)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isDisabled) {
                e.target.style.transform = 'scale(1)';
              }
            }}
          >
            {UI.loading ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                Sending...
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                Send Reset Link
              </div>
            )}
          </button>
        </form>
      ) : (
        /* Success Message */
        <div style={{
          width: '100%',
          maxWidth: '400px',
          backgroundColor: 'rgba(76, 175, 80, 0.1)',
          border: '2px solid #4caf50',
          borderRadius: '12px',
          padding: '30px',
          textAlign: 'center',
          flexShrink: 0
        }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '20px'
          }}>
            ✅
          </div>
          <h2 style={{
            color: '#4caf50',
            fontSize: '22px',
            fontWeight: 'bold',
            margin: 0,
            marginBottom: '15px'
          }}>
            Reset Link Sent!
          </h2>
          <p style={{
            color: '#4caf50',
            fontSize: '16px',
            margin: 0,
            lineHeight: '1.4'
          }}>
            Check your email (including spam folder) for the password reset link.
          </p>
        </div>
      )}

      {/* Back to Login Link */}
      <div style={{
        marginTop: '30px',
        textAlign: 'center',
        flexShrink: 0
      }}>
        <Link
          to="/login"
          style={{
            color: 'gold',
            fontSize: '16px',
            fontWeight: 'bold',
            textDecoration: 'none',
            borderBottom: '2px solid transparent',
            transition: 'border-bottom-color 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.borderBottomColor = 'gold';
          }}
          onMouseLeave={(e) => {
            e.target.style.borderBottomColor = 'transparent';
          }}
        >
          <i className="fa-solid fa-arrow-left" style={{ marginRight: '5px', fontSize: '16px' }}></i> Back to Login
        </Link>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  UI: state.UI
});

const mapDispatchToProps = {
  resetPassword
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordMobile);